import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './AccessibilityPage.scss';

class AccessibilityPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main
                role="main"
                className="conteneur conteneur-mobile"
                id="p-accessibility-declaration">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ACCESSIBILITY_DECLARATION_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.ACCESSIBILITY_DECLARATION_PATH
                        }
                    ]}
                />
                <h1>{i18n.TITLE1}</h1>

                <div className="subtitle">
                    <p>{i18n.TEXT1_1}</p>
                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_2)}</p>
                </div>

                <h2>{i18n.TITLE2}</h2>
                <p>{i18n.TEXT2_1}</p>

                <h2>{i18n.TITLE3}</h2>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_1)}</p>
                <ul>
                    <li>{i18n.TEXT3_2}</li>
                </ul>
                <p>{i18n.TEXT3_3}</p>
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT3_4)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT3_5)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT3_6)}</li>
                </ul>

                <h2>{i18n.TITLE4}</h2>
                <p>{i18n.TEXT4_1}</p>
                <h3>{i18n.TEXT4_2}</h3>
                <p>{i18n.TEXT4_3}</p>
                <ul>
                    <li>{i18n.TEXT4_3_1}</li>
                    <li>{i18n.TEXT4_3_2}</li>
                    <li>{i18n.TEXT4_3_3}</li>
                    <li>{i18n.TEXT4_3_4}</li>
                    <li>{i18n.TEXT4_3_5}</li>
                    <li>{i18n.TEXT4_3_6}</li>
                    <li>{i18n.TEXT4_3_7}</li>
                    <li>{i18n.TEXT4_3_8}</li>
                    <li>{i18n.TEXT4_3_9}</li>
                    <li>{i18n.TEXT4_3_10}</li>
                    <li>{i18n.TEXT4_3_11}</li>
                    <li>{i18n.TEXT4_3_12}</li>
                    <li>{i18n.TEXT4_3_13}</li>
                    <li>{i18n.TEXT4_3_14}</li>
                    <li>{i18n.TEXT4_3_15}</li>
                    <li>{i18n.TEXT4_3_16}</li>
                    <li>{i18n.TEXT4_3_17}</li>
                    <li>{i18n.TEXT4_3_18}</li>
                    <li>{i18n.TEXT4_3_19}</li>
                    <li>{i18n.TEXT4_3_20}</li>
                    <li>{i18n.TEXT4_3_21}</li>
                    <li>{i18n.TEXT4_3_22}</li>
                    <li>{i18n.TEXT4_3_23}</li>
                    <li>{i18n.TEXT4_3_24}</li>
                    <li>{i18n.TEXT4_3_25}</li>
                    <li>{i18n.TEXT4_3_26}</li>
                </ul>
                <h3>{i18n.TEXT4_4}</h3>
                <p>{i18n.TEXT4_4_1}</p>

                <h2>{i18n.TITLE5}</h2>
                <p>{i18n.TEXT5_1}</p>
                <h3>{i18n.TEXT5_2}</h3>
                <ul>
                    <li>{i18n.TEXT5_2_1}</li>
                    <li>{i18n.TEXT5_2_2}</li>
                    <li>{i18n.TEXT5_2_3}</li>
                </ul>
                <h3>{i18n.TEXT5_3}</h3>
                <p>{i18n.TEXT5_4}</p>
                <ul>
                    <li>{i18n.TEXT5_4_1}</li>
                    <li>{i18n.TEXT5_4_2}</li>
                    <li>{i18n.TEXT5_4_3}</li>
                </ul>
                <h3>{i18n.TEXT5_5}</h3>
                <ul>
                    <li>{i18n.TEXT5_5_1}</li>
                    <li>{i18n.TEXT5_5_2}</li>
                    <li>{i18n.TEXT5_5_3}</li>
                    <li>{i18n.TEXT5_5_4}</li>
                </ul>
                <h3>{i18n.TEXT5_6}</h3>
                <ol>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_7)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_8)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_9)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_10)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_11)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_12)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_13)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_14)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_15)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_16)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_17)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_18)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_19)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT5_20)}</li>
                </ol>

                <h2>{i18n.TITLE6}</h2>
                <p>{i18n.TEXT6_1}</p>
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT6_2)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT6_3)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT6_4)}</li>
                </ul>

                <h2>{i18n.TITLE7}</h2>
                <p>{i18n.TEXT7_1}</p>
                <p>{i18n.TEXT7_2}</p>
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT7_3)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT7_4)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT7_5)}</li>
                </ul>
            </main>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCESSIBILITY_DECLARATION
    };
}

export default withTemplate(connect(mapStateToProps)(AccessibilityPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/accessibility/AccessibilityPage.js